/*
  Shows a "Read more" toggle under the collection description on mobile only,
  and only when the description is actually clamped to 3 lines (see the
  -webkit-line-clamp rule in sections/collection-banner.liquid) - a short
  description that already fits within 3 lines never gets a toggle it
  doesn't need.
*/
(function () {
  const description = document.querySelector('.collection-banner__description');
  const button = document.querySelector('.collection-banner__read-more');
  if (!description || !button) return;

  function update() {
    if (description.classList.contains('is-expanded')) {
      button.hidden = false;
      return;
    }
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    button.hidden = !isMobile || description.scrollHeight <= description.clientHeight + 1;
  }

  button.addEventListener('click', () => {
    const expanded = description.classList.toggle('is-expanded');
    button.textContent = expanded ? 'Read less' : 'Read more';
  });

  window.addEventListener('resize', update);
  update();
})();
